export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-brand">
          <svg className="footer-logo" width="24" height="24" viewBox="0 0 32 32" fill="none">
            <path 
              d="M8 20C5.8 20 4 18.2 4 16C4 14.1 5.4 12.5 7.2 12.1C7.1 11.7 7 11.4 7 11C7 8.8 8.8 7 11 7C12.1 7 13.1 7.5 13.8 8.2C14.8 6.9 16.3 6 18 6C20.8 6 23 8.2 23 11C23 11.3 23 11.7 22.9 12C25.2 12.3 27 14.3 27 16.5C27 18.9 25 21 22.5 21" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round"
            />
          </svg>
          <span className="footer-name">DreamWright</span>
        </div>
        <div className="footer-links">
          <a href="#">About</a>
          <a href="#">Pricing</a>
          <a href="#">Privacy</a>
          <a href="#">Terms</a>
        </div>
        <p className="footer-copy">&copy; 2026 DreamWright. All rights reserved.</p>
      </div>
    </footer>
  )
}
